
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/legal-stuff",
      function () {
        return require("private-next-pages/fr/en/legal-stuff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/legal-stuff"])
      });
    }
  